import Component from '../Component';
import { Breakpoints } from '../constants';

/* Place the sale or sold out badge at the top left of preview thumbnail
* image/s, rather than the top left of the containing <div>.
*/
export default class Badge extends Component {
  constructor(theme, element) {
    super(theme, element);
    this.roots = [];
  }

  add = (element, timeout) => {
    this.roots.push(element);
  }

  onWindowResize = () => {
    const containers = this.roots.flatMap(root => Array.from(root.querySelectorAll('.grid-view-item .grid-view-item-image')));
    const badges = containers.flatMap(container => Array.from(container.querySelectorAll('.badge')));
    badges.forEach(badge => badge.style.opacity = '0');
    badges.forEach(badge => badge.style.opacity = '1');
  }
}
